import Box from '@mui/material/Box';

// @transform-path ../../../../../../src/assets/corporate-memphis/happy-family1.png
import happyFamily1 from '@/assets/corporate-memphis/happy-family1.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/elderly-couple1.png
import elderlyCouple1 from '@/assets/corporate-memphis/elderly-couple1.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/elderly-couple2.png
import elderlyCouple2 from '@/assets/corporate-memphis/elderly-couple2.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/kindness1.png
import kindness1 from '@/assets/corporate-memphis/kindness1.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/planning.png
import planning from '@/assets/corporate-memphis/planning.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/starting.png
import starting from '@/assets/corporate-memphis/starting.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/regular.png
import regular from '@/assets/corporate-memphis/regular.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/end-of-life.png
import endOfLife from '@/assets/corporate-memphis/end-of-life.png';

export type MemphisSize = 'sm' | 'md' | 'lg';
export type MemphisVariant =
  | 'happy-family-1'
  | 'elderly-couple-1'
  | 'elderly-couple-2'
  | 'kindness-1'
  | 'planning'
  | 'starting'
  | 'regular'
  | 'end-of-life';

const images: { [key in MemphisVariant]: any } = {
  'happy-family-1': happyFamily1,
  'elderly-couple-1': elderlyCouple1,
  'elderly-couple-2': elderlyCouple2,
  'kindness-1': kindness1,
  planning: planning,
  starting: starting,
  regular: regular,
  'end-of-life': endOfLife,
};

const sizeHeight: Record<MemphisSize, string> = {
  sm: '100px',
  md: '250px',
  lg: '400px',
};

export const Memphis = ({
  className,
  variant = 'happy-family-1',
  size = 'md',
}: MemphisProps) => {
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        overflow: 'hidden',
        height: sizeHeight[size],
      }}
    >
      <Box
        component='img'
        src={images[variant]}
        alt='warm image'
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          objectFit: 'contain',
          maxHeight: '100%',
        }}
      />
    </Box>
  );
};

interface MemphisProps {
  className?: string;
  variant?: MemphisVariant;
  size?: MemphisSize;
}

Memphis.displayName = 'Memphis';

export default Memphis;
